import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = ['input', 'copyButton']

  connect() {
  }

  highlight() {
    const el = this.inputTarget;

    if (el.focus) el.focus();

    if (typeof el.select === "function") {
      el.select();
    } else {
      const range = document.createRange();
      range.selectNodeContents(el);

      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
    }

    if (this.hasCopyButtonTarget) {
      this.copyButtonTarget.classList.remove("hidden");

      if (this.copyButtonTarget.classList.contains("button-secondary")) {
        this.copyButtonTarget.classList.remove("button-secondary");
        this.copyButtonTarget.innerHTML = "Copy";
      }
    }
  }

  copy() {
    document.execCommand("copy");

    if (this.hasCopyButtonTarget) {
      this.copyButtonTarget.classList.add("button-secondary");
      this.copyButtonTarget.innerHTML = "Copied";
    }
  }

  defocus(event) {
    if (!this.element.contains(event.target)) {
      if (this.hasCopyButtonTarget) {
        this.copyButtonTarget.classList.add("hidden");
      }
    }
  }
}
